import {
  ImageContentType,
  extractMimeType,
  PreviewContent,
  isSupportedSvgMimeType,
  isSupportedImageMimeType,
} from '@ardoq/api-types';
import { handleNetworkError, toResponseError } from './api';
import { ApiResponse } from './types';
import { toArdoqError } from '@ardoq/common-helpers';

const toResponse = async (response: Response): ApiResponse<PreviewContent> => {
  if (!response.ok) {
    return toResponseError(response);
  }
  try {
    const contentType = extractMimeType(
      response.headers.get('content-type') ?? ''
    );

    if (isSupportedSvgMimeType(contentType)) {
      const svg = await response.text();

      return { content: svg, contentType: ImageContentType.SVG };
    }

    if (isSupportedImageMimeType(contentType)) {
      const blob = await response.blob();

      return {
        content: URL.createObjectURL(blob),
        contentType: ImageContentType.IMAGE,
      };
    }

    return toArdoqError({
      error: new Error(`File type ${contentType} is not supported`),
      userMessage: 'Invalid file type',
    });
  } catch (err) {
    return toArdoqError({
      error: new Error('Failed to parse content'),
      userMessage: 'Unable to parse content',
    });
  }
};

const fetchImagePreview = (url: string): ApiResponse<PreviewContent> => {
  const request = new Request(url);

  return window
    .fetch(request)
    .then(response => toResponse(response))
    .catch(error => handleNetworkError(request, error));
};

export const imagePreviewApi = {
  fetchImagePreview,
};
